import gql from 'graphql-tag';

const publicAppSearchQuery = gql`
  query publicAppSearchQuery(
    $nameContains: String!
    $limit: Int!
    $excludeUpcoming: Boolean
  ) {
    getAppsByNameContains(
      nameContains: $nameContains
      limit: $limit
      excludeUpcoming: $excludeUpcoming
    ) {
      edges {
        id
        slug
        name
        currentImplementation {
          id
        }
        images {
          url_16x16
          url_32x32
          url_64x64
          url_128x128
        }
      }
    }
  }
`;

export default publicAppSearchQuery;
